import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import { CssBaseline, CircularProgress, Container, Button, Grid } from "@mui/material"
import { withStyles } from "@mui/styles"
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import MaterialTable from 'material-table'
import AddIcon from '@mui/icons-material/Add'
import { Link } from 'react-router-dom'
import MyMaterialTable from '../../components/table'
import Api from "../../services/api"
import * as CalledService from '../../services/called.service'
import * as calledsActions from '../../redux/actions/calleds'
import { Can } from '../../config/ability-context'
import { AbilityContext } from '../../config/ability-context'
import Footer from '../../components/footer'
import moment from "moment"
import { FormattedMessage } from 'react-intl'
import { injectIntl } from 'react-intl'
import { getSlaAtendimento, getSlaSolucao } from '../called-list/called.functions'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import { saveAs } from 'file-saver'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete'
import Pagination from '@mui/material/Pagination'
import Search from '@mui/icons-material/Search'
import TextField from '@mui/material/TextField'
import autoTable from 'jspdf-autotable'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import LogoMarca from '../../images/new-logo-cmtech.png'
import html2canvas from 'html2canvas'
import Divider from '@mui/material/Divider'
import * as ExcelJS  from 'exceljs'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import fileDownload from 'js-file-download'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import ApiReports from "../../services/apireport";
import ScheduleReportButton from "../../components/report-schedule";
import { PapiroConsole } from "../../utils/papiroConsole"
import SimpleAutoCompleteMultiple from '../../components/auto-complete/autocomplete-multiple';
import SimpleCheckBox from "../../components/checkbox/check";
import * as Service from '../../services/techinicalteamorganizationcategory.service';
import {cpfMask, validateCpf} from "../../utils/cpfUtils";
import { getProviderList as getProviderListService } from '../../services/2talk/omnichannel'

class ClicksOnSatisfactionSurvey extends Component {

    constructor(props) {
        super(props)

        this.isClient = true
        this.isAdm = false
        this.typingTimeout = null
        this.organizationId=null
        
        const { userSession } = this.props

        if(userSession == null ||  userSession.user == null || userSession.user.userrole == null)
        Api.logoff()

        userSession.user.userrole.map((item, key) => {
        if(item.role.roletype !=3)
            this.isClient = false
        if(item.role.roletype == 0 || item.role.roletype == 1)
            this.isAdm = true
        });

        if(userSession.user.organization)
            this.organizationId = userSession.user.organization.id
            
        this.state = {
            dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
            dateEnd:moment().format('YYYY/MM/DD HH:mm:ss'),
            recipient: '',
            organizationId: this.organizationId,
            OrganizationFilter: 0,
            location: 0,
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            showGrid: false,
            calledsStatsList: [],
            organizationList: [],
            organizationAddressesList: [],
            calledPdfList:[],
            totalPages:0,
            page:1,
            pageStart:0,
            pageEnd:0,
            count:0,
            searchValue: '',
            showHeader:false,
            strhtmlModalOpen: false,
            dialogHTMLString: '',
            totalClicks: 0,
            calledId: '',
            requestingUserId: '',
            requestingUserName: '',
            requestingUserEmail: '',
            groupList: [],
            groupId: 0,
            OrgsList: [],
            allOrganizations: false,
            allOrganizationsBackup: [],
            OrganizationListFilter: [],
            TechinicalTeamFilter: { id: 0, name: '' },
            TechinicalTeamList: [],        
            calledCreatedAt: "",
            calledOriginRequestTitle: "",
            calledTypeName: "",
            createdAt: "",
            deleted: false,
            groupName: "",
            id: "",
            organizationName: "",
            optionsMessageProviders: [],
            MessageProviderId: 0
            
        }

        this.onChange = this.onChange.bind(this)
    }


    changeValues = async (stateName, value, text = '') => {
        this.setState({ loading: true })

        if (stateName === 'groupId') {
            const selectedGroupId = value ? value.id : 0;
            const backupList = this.state.fullOrgList || this.state.allOrganizationsBackup || [];

            if (selectedGroupId === 0) {
                this.setState({
                    groupId: 0,
                    OrgsList: backupList, 
                    OrganizationListFilter: [], 
                    loading: false
                });
                return;
            }

            const filteredOrgs = backupList.filter(org =>
                (org.groupId === selectedGroupId) ||
                (org.groupid === selectedGroupId) ||
                (org.GroupId === selectedGroupId) ||
                (org.Group && org.Group.Id === selectedGroupId)
            );

            this.setState({
                groupId: selectedGroupId,
                OrgsList: filteredOrgs,
                OrganizationListFilter: [], 
                loading: false
            });
            return;
        }

        else if (stateName === 'OrganizationListFilter') {
            await this.handleOrganizationListFilterChange(stateName, value);
        }else if (stateName === 'allOrganizations') {
            
            this.setState({ OrganizationListFilter: this.state.OrgsList });
        }

        this.setState({ [stateName]: value });

        this.setState({ loading: false })
    };


    Reload = () => {
        const reload = localStorage.getItem('reload')
        if(reload == "true" )
        localStorage.setItem('reload', false)
        return null;
    }

    onChangePaginate = (e,page) =>{
        this.setState({ page:page })
        this.getStatsCalleds('',page)
    }

    setPagination = (count,page) => {
        let totalPage = Math.ceil (count/10)
        this.setState({ totalPages:totalPage })
        if(count > 0){
        if(page == 1){
            if(count < 10)
            this.setState({pageStart:1, pageEnd:count})
            else
            this.setState({pageStart:1, pageEnd:10})
        } else{
            let pageStart = ((page - 1) * 10) + 1
            if(count >= page * 10)
            this.setState({pageStart:pageStart, pageEnd:page * 10})
            else
            this.setState({pageStart:pageStart, pageEnd:count})
        }
    } else
        this.setState({totalPages:0, page:1, count:0})
    }

    getOrganizationAddresses = async organizationId => {
        this.setState({ loading: true })

        const result = await CalledService.getOrganizationAddresses(organizationId)
        if (result.success) {
        if(this.isTec == false){
            if(result.data.length < 1  ){
            this.setState({
                loading: false, openNotification: true, notificationVariant: "error",
                notificationMessage: this.props.intl.formatMessage({id:"called.accompaniment.notification.organization.no.registered.address"})
            })
            }
        }
                
        // this.setState({ loading: false, organizationAddressesList: result.data })
        } else {
        const intl = this.props.intl
        this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({id:"process.error"})
        })
        Api.kickoff(result)
        }
    };

    onFieldChange = event => {
        // Clears the previously set timer.
        clearTimeout(this.typingTimeout)
        // Reset the timer, to make the http call after 475MS (this.callSearch is a method which will call the search API. Don't forget to bind it in constructor.)
        this.typingTimeout = setTimeout(this.callSearch, 475);
        this.setState({ [event.target.name]: event.target.value, page:1 })
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value })
    }

    callSearch = _ => {
        this.getCalleds('',this.state.page)
    }

    getOrganizations = async _ => { 
        let data = [];
        const { userSession } = this.props

        if(userSession && userSession.user && userSession.user.userorganizations && userSession.user.userorganizations.length > 0) {
            data = userSession.user.userorganizations
        } else {
            await Api.get('/organizations/tech').then(result => {
                data = result.data.data
            }).catch(err => {
                data = err
            });
        }
        this.setState({ organizationList: data, 
                        OrgsList: data,      
                        fullOrgList: data  })
    }
    


    async componentDidMount() {
        this.setState({loading: true})

        await this.getGroups();
        await this.getTechinicalTeams();
        await this.getOrganizations().then(() => {
            this.setState({
                fullOrgList: this.state.OrgsList, 
                allOrganizationsBackup: this.state.OrgsList 
            });
        });
        await this.getProviderList();

        this.setState({loading: false})  
    }
  
    componentWillReceiveProps(nextProps){
        if(nextProps.location.state === "sendMailReports")
            this.getCalleds(this.props.location.state)
        else if(nextProps.location.state === "assignedcalleds")
            this.getCalleds(nextProps.location.state)
        else if(nextProps.location.state === "reload")
            this.componentDidMount()
    }    


    getStatsCalleds = async (filter = '',page = 1) => {

        const intl = this.props.intl;

        this.setState({ loading: true });

        let url = `/report/2talk-cliks-on-satisfaction-survey-report/paginate?page=${page}`

        let messageProviderId = this.state.MessageProviderId && this.state.MessageProviderId.id ? this.state.MessageProviderId.id : 0;
        
    
        
        if(this.state.searchValue != '')
        url += `&search=${this.state.searchValue}`
        
        if(filter != '')
        url =url+ '&filter='+filter
            
        url += `&dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}&requestingUserId=${this.state.requestingUserId}&calledId=${this.state.calledId}&organizationId=${this.state.OrganizationListFilter.length > 0 ? this.state.OrganizationListFilter.map(item => item.id).join(',') : ''}&groupId=${this.state.groupId}&requestingUserName=${this.state.requestingUserName}&requestingUserEmail=${this.state.requestingUserEmail}&messageProviderId=${messageProviderId}`

        this.setState({ showGrid: true, scheduleRequest: url })

        var writing = ""

        ApiReports.get(url)
        .then(result => {
            if (result.data.success) {
                let count = result.data.count
                this.setState({count:count})
                this.setPagination(count,page)

                const formattedList = result.data.data.map(item => {
                    return {
                        ...item,
                        totalClicks: item.totalclicks, 
                        calledTitle: item.calledtitle,
                        feedbackId: item.feedbackid,
                        calledId: item.calledid,
                        requestingUserId: item.requestinguserid,
                        requestingUserName: item.requestingusername,
                        requestingUserEmail: item.requestinguseremail,
                        calledCreatedAt: this.formatDate(item.calledcreatedat),
                        calledOriginRequestTitle: item.calledoriginrequesttitle,
                        calledTypeName: item.calledtypename,
                        createdAt: this.formatDate(item.createdat),
                        groupName: item.groupname,
                        organizationName: item.organizationname
                    }
                })

                this.setState({ calledsStatsList: formattedList, loading:false })

            } else{
            this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
            })
            Api.kickoff(result)
            }
        })
        .catch(err => {
            this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
            })
            Api.kickoff(err)
        })
    }

    getFileNew = async () => {
        this.setState({ loading: true });

        let url = `/report/2talk-cliks-on-satisfaction-survey-report/excel?`;
        
        
        // Mesmos filtros do paginate: antes só ia data/solicitante/chamado — sem messageProviderId a API quebrava e
        // organização/grupo/nome/e-mail eram ignorados.
        let messageProviderId = this.state.MessageProviderId && this.state.MessageProviderId.id ? this.state.MessageProviderId.id : 0;
        url += `&dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}&requestingUserId=${this.state.requestingUserId}&calledId=${this.state.calledId}&organizationId=${this.state.OrganizationListFilter.length > 0 ? this.state.OrganizationListFilter.map(item => item.id).join(',') : ''}&groupId=${this.state.groupId}&requestingUserName=${this.state.requestingUserName}&requestingUserEmail=${this.state.requestingUserEmail}&messageProviderId=${messageProviderId}`

        
        ApiReports.get(url)
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'success',
                        notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")",
                    });
                } else {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: response.data.errors && response.data.errors[0] ? 
                            response.data.errors[0] : 
                            this.props.intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(response);
                }
            })
            .catch((error) => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: error.response && error.response.data && error.response.data.errors ? 
                        error.response.data.errors[0] : 
                        this.props.intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(error);
            });
    }

    handleSubmit = async e => {
        const intl = this.props.intl;
        e.preventDefault();
        this.setState({ loading: true });

        var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
        var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')
        if(dateStart > dateEnd){
            
            this.setState({
                openNotification: true,
                notificationVariant: "error",
                notificationMessage:intl.formatMessage({id:"report.audit.initial.date.higher.than.end.date"}),
                loading :false
            });
    
        } else {
        await this.getStatsCalleds(this.props.location.state)
        }

        
    }

    closeNotification = _ => {
        this.setState({ openNotification: false });
    }

    getGroups = async () => {
        try {

            const result = await Api.get('/groups');

            if (result.data) {
            
            const lista = result.data.data || result.data;
            this.setState({ groupList: lista });
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                openNotification: true, notificationVariant: 'error',
                notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
        }
    }
    async handleOrganizationListFilterChange(stateName, value) {
        if (stateName !== 'OrganizationListFilter') return;

        const organizationListFilterIds = value.map(item => item.id);

        this.setState({ [stateName]: organizationListFilterIds });

        if (organizationListFilterIds.length > 0) {
            await this.getTechinicalTeams(organizationListFilterIds)

            if (!this.state.TechinicalTeamList.find(t => t.id == this.state.TechinicalTeamFilter.id)) {
                this.setState({ TechinicalTeamFilter: { id: 0, name: '' } })
            }

        } else {
            this.setState({ TechinicalTeamFilter: { id: 0, name: '' }, TechinicalTeamList: [], customFieldId: [] })
            await this.getTechinicalTeams()
        }


    }

    async getTechinicalTeams(OrganizationId = []) {
        var result = null

        if (OrganizationId.length > 0) {
        result = await Service.getTechinicalTeamsByOrganizationList(OrganizationId);
        } else {
        result = await Service.getTechinicalTeams()
        }

        if (result.success) {
        this.setState({ TechinicalTeamList: result.data });

        } else {
        const intl = this.props.intl;
        this.setState({
            openNotification: true, notificationVariant: 'error',
            notificationMessage: result.response && result.response.data && result.response.data.errors && result.response.data.errors[0] ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        });
        Api.kickoff(result);
        }
    }
    
    formatDate = (dateString) => {
        if (!dateString) return '-';
        
        try {
            const date = new Date(dateString);
            
            // Verifica se a data é válida
            if (isNaN(date.getTime())) {
                return dateString;
            }
            
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            
            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        } catch (error) {
            return dateString;
        }
    };

    async getProviderList(){
        if(this.state.optionsMessageProviders.length > 0) return;

        let result = await getProviderListService()
        if (result && result.success) {
            const messageProviderOptions = result.data;
            
            this.setState({ optionsMessageProviders: messageProviderOptions })
        } else {
            const intl = this.props.intl;
            this.setState({
                openNotification: true, notificationVariant: 'error',
                notificationMessage: result.response && result.response.data && result.response.data.errors && result.response.data.errors[0] ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);
        }
    }


    render() {
        const { classes, headerMenu, actionsHeaderMenu } = this.props
        const intl = this.props.intl

        if(Api == null) {
        var l = this.props.match.params.lang;
        document.location.href=`/${l}/unavailable`
        }

        const tableList = () => {
        return (
            <>
            <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'> 
            <Accordion >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className={classes.heading}>{intl.formatMessage({id:"filters"})}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container style={{marginBottom:20}}>
                        <Grid item xs={12} sm={6} md={3}>
                            <SimpleDatePicker label={intl.formatMessage({id:"start.date"})} name='dateStart' stateName='dateStart' changeDate={this.changeValues} currentDate={this.state.dateStart} required/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <SimpleDatePicker label={intl.formatMessage({id:"end.date"})} name='dateEnd' stateName='dateEnd' changeDate={this.changeValues} currentDate={this.state.dateEnd}  required/>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <SimpleAutoComplete label="Grupo" options={this.state.groupList} stateName='groupId' selected={this.state.groupList.find(x => x.id === this.state.groupId) || null} changeSelect={this.changeValues} getOptionLabel={(option) => option.Name || option.name || ""}/>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} style={{marginTop:10}}>
                            <SimpleAutoCompleteMultiple key={this.state.groupId} label={intl.formatMessage({ id: "organization" })} options={this.state.OrgsList} stateName='OrganizationListFilter' changeSelect={this.changeValues}  />        
                            <SimpleCheckBox label={intl.formatMessage({ id: "select.all.organizations" })} name='allOrganizations' stateName='allOrganizations' changeSelect={this.changeValues} />
                        </Grid>

                        <Grid item xs={24} sm={12} md={8} lg={6} style={{marginLeft:10, marginTop:10}}>
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <SimpleAutoComplete label={intl.formatMessage({ id: "select.message_provider" })} options={this.state.optionsMessageProviders} stateName='MessageProviderId' selected={this.state.MessageProviderId} changeSelect={this.changeValues} />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3} style={{marginLeft:10, marginTop:10}}>
                            <TextField  type="text"
                                        fullWidth
                                        inputProps={{ maxLength: 255 }}
                                        autoComplete="fname"
                                        variant="outlined"
                                        name="requestingUserName"
                                        value={this.state.requestingUserName}
                                        placeholder={intl.formatMessage({id:"requesting.user.name"})}
                                        onChange={this.onChange}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3} style={{marginLeft:10, marginTop:10}}>
                            <TextField  type="email"
                                        fullWidth
                                        inputProps={{ maxLength: 255 }}
                                        autoComplete="email"
                                        variant="outlined"
                                        name="requestingUserEmail"
                                        value={this.state.requestingUserEmail}
                                        placeholder={intl.formatMessage({id:"requesting.user.email"})}
                                        onChange={this.onChange}/>
                        </Grid>


                        

                    </Grid>  
                </AccordionDetails>
                </Accordion>
                




                <Grid container style={{marginBottom:10}}>
                <Grid item xs={12} sm={2} md={2} style={{marginRight:10,marginTop:10}}>
                    <Button
                    type='submit'
                    fullWidth
                    variant='contained'
                    color='secondary' >
                    {<FormattedMessage id="filter" />}
                    </Button>
                </Grid>

                { this.state.showGrid  && <Grid item xs={12} sm={5} md={2} style={{marginRight:10,marginTop:10}}>
                    <Button
                    fullWidth
                    variant='contained'
                    color='secondary'
                    onClick={this.getFileNew} >
                    {<FormattedMessage id="export.plan" />}
                    </Button>
                </Grid>}
{this.state.showGrid && this.state.scheduleRequest && <Grid item xs={12} sm={5} md={2} style={{marginRight:10,marginTop:10}}>
  <ScheduleReportButton reportKey="clicks-satisfaction-survey" request={this.state.scheduleRequest} color="secondary" />
</Grid>}
                </Grid>                                   
            </form>
                    
            {
            this.state.showGrid && <> 
                <MyMaterialTable
                title=""
                columns={
                    [                    
                        { title: intl.formatMessage({ id: "total.clicks.on.satisfaction.survey" }), field: 'totalclicks' },                        
                        { title: intl.formatMessage({ id: "called.id" }), field: 'calledid' },
                        { title: intl.formatMessage({ id: "called.list.data.edit.called.title" }), field: 'calledtitle' },
                        { title: intl.formatMessage({ id: "requesting.user.name" }), field: 'requestingusername' },
                        { title: intl.formatMessage({ id: "requesting.user.email" }), field: 'requestinguseremail' },
                        { title: intl.formatMessage({ id: "called.create.at" }), field: 'calledCreatedAt' },
                        { title: intl.formatMessage({ id: "origin.call" }), field: 'calledoriginrequesttitle' },
                        { title: intl.formatMessage({ id: "call.type" }), field: 'calledtypename' },
                        { title: intl.formatMessage({ id: "creation.date" }), field: 'createdAt' },
                        { title: intl.formatMessage({ id: "onboarding.tour.createOrganization.group.title" }), field: 'groupname' },
                        { title: intl.formatMessage({ id: "menu.organization" }), field: 'organizationname' }
                    ]} 
                data={this.state.calledsStatsList} />

                <Grid container style={{marginBottom:12,marginTop:8}}>
                <Grid item xs={12} md={3}>
                    <Pagination  count={this.state.totalPages} page={this.state.page}  onChange={this.onChangePaginate} />
                </Grid>
                <Grid item xs={12} sm={3} style={{marginTop:6}}>
                    {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                </Grid>
                </Grid>
            </>
            }
            </>
        );
        }

        return (
            <div className={classes.root} style={{paddingLeft:0, marginLeft:0}}>
                <HeaderMenu />
                <main
                className={clsx(classes.content, {
                    [classes.contentShift]: headerMenu.open,
                }, classes.actionsContent, {
                    [classes.actionscontentShift]: actionsHeaderMenu.open,
                })} >
                <div className={classes.drawerHeader} />
                <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft:0, marginLeft:0}}>
                    <CssBaseline />
                {this.state.showHeader && 
                    <Grid container>
                    <Grid id="header-pdf" item lg={4} sm={12} xl={this.state.grid} xs={12} style={{padding: '2px', minWidth:600}}>
                        <Card >
                        <CardContent>
                            <img src={LogoMarca} style={{width:"70px"}}/> <span style={{marginLeft:25, fontSize:18}}> {<FormattedMessage id="menu.2talk.clicks.on.satisfaction.survey" />}</span>
                            <Divider />
                        </CardContent>
                        </Card>  
                    </Grid>
                    </Grid>
                }
                
                    <Grid container spacing={6}> 
                    <Grid item xs={12} sm={12}>
                        <Card >
                        <CardContent className="background-title-search">
                            <Typography variant="h5">
                            {<FormattedMessage id="menu.2talk.clicks.on.satisfaction.survey" />}
                            </Typography>
                        </CardContent>
                        </Card>
                    </Grid>
                    </Grid>
                
                    <Can I="List" a="SendMailReport">
                        {tableList()}
                    </Can>

                {this.state.loading && (
                    <Overlay>
                    <CircularProgress color="secondary" />
                    </Overlay>
                )}

                    <CustomizedSnackbars
                    variant={this.state.notificationVariant}
                    message={this.state.notificationMessage}
                    isOpen={this.state.openNotification}
                    toClose={this.closeNotification} />
                </Container>
                </main>
            <Footer />                    
            </div>
        )
    }
}

ClicksOnSatisfactionSurvey.propTypes = {
  classes: PropTypes.object.isRequired
}


const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ClicksOnSatisfactionSurvey)))
ClicksOnSatisfactionSurvey.contextType = AbilityContext
